import React from "react";

type Props = {
  videoSrc?: string;     
  poster?: string;       
  audioSrc?: string;   
};

export default function CommentCaMarche({ videoSrc, poster, audioSrc }: Props) {
  return (
    <section className="relative mx-auto max-w-[1219px] px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-[58%_42%] gap-10 lg:gap-16 items-center">
        <div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Comment ça marche ?</h2>
          <p className="mt-4 text-[15px] sm:text-base text-neutral-700 leading-relaxed max-w-[640px]">
          On le sait, faire tourner les commerces proximité c’est favoriser l’économie locale. L’app PACTE tente de rendre cet engagement plus ludique. À chaque visite chez vos commerçants : scannez le QR-code au moment du paiement, cumulez des tampons sur votre carte virtuelle et profitez des offres permanentes. De plus, les commerçants pourront vous proposer des offres ponctuelles dont vous serez notifiés en temps réel. L'app PACTE, ce n’est pas seulement des offres de fidélité : c’est aussi un lien direct avec la vie locale. Retrouvez les actualités de nos partenaires et les événements à ne pas manquer près de chez vous.
          </p>

          <a
            href="https://download.pacte-claix.fr"
            target="_blank"
            className="mt-6 inline-flex items-center justify-center rounded-full bg-black text-white
                       px-6 py-3 text-sm sm:text-base font-medium
                       shadow-[0_10px_24px_rgba(0,0,0,0.35)] hover:opacity-90 transition"
          >
            Télécharger l’application
          </a>
        </div>

        <div className="flex md:justify-end">
          <div className="w-full max-w-[320px]">
            <div className="relative rounded-[32px] bg-neutral-200 border border-black/10 shadow-[0_6px_24px_rgba(0,0,0,0.18)] overflow-hidden">
              <div className="relative w-full aspect-[9/19.5] bg-neutral-300">
                {videoSrc ? (
                  <video
                    src={videoSrc}
                    poster={poster}
                    className="absolute inset-0 h-full w-full object-cover"
                    controls
                    playsInline
                  />
                ) : (
                  <div className="absolute inset-0 grid place-items-center text-neutral-600">
                    <span className="text-sm sm:text-base">video motion</span>
                  </div>
                )}
              </div>

          
            </div>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute -left-[35%] bottom-0 translate-y-1/3 w-[380px] h-[180px]
                   rounded-[66px] rotate-[-50deg] bg-[#F7B1CB] opacity-90 hidden sm:block"
      />
    </section>
  );
}